import { Status } from '../../../../types/redux/data/dataTypes';
import { cn } from '../../../../utilities/cn';
import LoadingSpinner from '../../../ui/LoadingSpinner';
import { mapStatusToColor } from '../../../../utilities/colorUtilities';

interface CompareFiguresStatusBoxProps {
  currentValue: number | string;
  publishedValue: number | string;
  documentValue?: number | string | null;
  status: Status;
  isLoadingDocuments: boolean;
}

function CompareFiguresStatusBox({
  currentValue,
  publishedValue,
  documentValue,
  status,
  isLoadingDocuments,
}: CompareFiguresStatusBoxProps) {
  const isDocValueEmpty =
    documentValue === null ||
    documentValue === undefined ||
    (typeof documentValue === 'string' && documentValue.trim() === '');

  return (
    <div className="flex justify-center items-center h-full w-full">
      <div
        className="flex flex-col 2xl:flex-row w-[8rem] 2xl:w-[20rem] min-h-[2.2rem] items-stretch 2xl:items-center justify-between gap-x-1 2xl:gap-x-1 gap-y-2 2xl:gap-y-0 rounded-md border border-gray-200 bg-white px-2 py-1 shadow-sm"
      >

        {/* Current Value */}
        <div
          className="flex flex-1 flex-col items-center rounded px-2 py-1"
          style={{ backgroundColor: mapStatusToColor(status) }}
        >
          <span className="mb-0.5 text-xs font-medium text-white">Current</span>
          <span className="text-sm font-semibold text-white">{currentValue}</span>
        </div>

        {/* Document Value */}
        <div
          className={cn(
            'flex flex-1 flex-col items-center justify-center rounded px-2 py-1',
            isDocValueEmpty && !isLoadingDocuments ? 'bg-red-600' : 'bg-white',
          )}
        >
          <span
            className={cn(
              'mb-0.5 text-xs font-medium',
              isDocValueEmpty && !isLoadingDocuments
                ? 'text-white'
                : 'text-gray-500',
            )}
          >
            Document
          </span>

          {isLoadingDocuments ? (
            <LoadingSpinner className="h-5 w-5 border-[3px] border-gray-300 border-b-[var(--mainBlue)]" />
          ) : isDocValueEmpty ? (
            <span className="text-sm font-semibold text-white">No data</span>
          ) : (
            <span className="text-sm font-semibold text-gray-700">
              {documentValue}
            </span>
          )}
        </div>

        {/* Published Value */}
        <div className="flex flex-1 flex-col items-center rounded bg-white px-2 py-1">
          <span className="mb-0.5 text-xs font-medium text-gray-500">
            Published
          </span>
          <span className="text-sm font-semibold text-blue-700">
            {publishedValue}
          </span>
        </div>
      </div>
    </div>
  );
}

export default CompareFiguresStatusBox;
